export default "__VITE_ASSET__CHBNDQ66__"